export default "__VITE_ASSET__0cc814cb__"